<template>
  <div class="level is-marginless">
    <div class="level-left">
      <div class="level-item">
        <p><strong>{{ item.name }}</strong></p>
      </div>
    </div>
    <div class="level-right">
      <div class="level-item">
        <p>
          <small>{{ item.quantity }}</small>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'item',
    props: ['item']
  }
</script>



// WEBPACK FOOTER //
// src/components/Item.vue